/* eslint-disable react/jsx-closing-tag-location */
import { lazy, Suspense } from 'react';
import PriorAuthRequestSummaryWrapper from './PrecertificationSummary/PriorAuthRequestSummaryWrapper.component';
import CallBackServiceWrapper from '../services/Auth/callbackwrapper.service';
import PrecertificationReview from './PrecertificationReview/precertificationReview';
import CircularIndeterminate from '../components/CircularProgress/circularprogress.component';
import PrecertificationIntakewrapper from './PrecertificationIntake/precertificationIntakewrapper';
import CallBackServiceSACBLWrapper from '../services/Auth/CallBackServiceSACBLWrapper.service';
import AdditionalClinicalUploadWrapper from
  '../components/AdditionalClinicalUpload/AdditionalClinicalUploadWrapper.service';

const AppWrapper = lazy(() => import('../AppWrapper'));

const routesConfig = [
  {
    path: '/',
    element: <Suspense fallback={<CircularIndeterminate />}>
      <AppWrapper />
    </Suspense>,
  },
  {
    path: '/callback',
    element: <CallBackServiceWrapper />,
  },
  {
    path: '/callbackSACBL',
    element: <CallBackServiceSACBLWrapper />,
  },
  {
    path: '/precertificationIntake',
    element: <PrecertificationIntakewrapper />,
  },
  {
    path: '/precertificationReview',
    element: <PrecertificationReview />,
  },
  {
    path: '/precertificationSummary',
    element: <PriorAuthRequestSummaryWrapper />,
  },
  {
    path: '/additionalClinicalUpload',
    element: <AdditionalClinicalUploadWrapper />,
  },
];

export default routesConfig;
